export const TaskService = {
	maintenance: 1,
	cleaning: 2,
	outside: 3,
	deviation: 4,
	customerRelated: 5,
	storage: 6,
	routines: 7,
	other: 8,
	incoming: 9,
	outgoing: 10,
	op: 11,
	rebuildPallets: 12,
};


// Services driven by the mobile app flow: service is locked after task
// creation and is not available for recurring tasks.
export const TaskServicesMobileFlow = [
	TaskService.incoming,
	TaskService.outgoing,
	TaskService.op,
	TaskService.rebuildPallets,
];


export const TaskServiceNames = {
	[TaskService.maintenance]: "Maintenance",
	[TaskService.cleaning]: "Cleaning",
	[TaskService.outside]: "Outside",
	[TaskService.deviation]: "Deviation",
	[TaskService.customerRelated]: "Customer related",
	[TaskService.storage]: "Storage",
	[TaskService.routines]: "Routines",
	[TaskService.other]: "Other",
	[TaskService.incoming]: "Incoming",
	[TaskService.outgoing]: "Outgoing",
	[TaskService.op]: "OP",
	[TaskService.rebuildPallets]: "Rebuild pallets",
};


export const TaskServices = {
	[TaskService.maintenance]: {
		full_name: "Maintenance",
		short_name: "MNT",
	},
	[TaskService.cleaning]: {
		full_name: "Cleaning",
		short_name: "CLN",
	},
	[TaskService.outside]: {
		full_name: "Outside",
		short_name: "OUT",
	},
	[TaskService.deviation]: {
		full_name: "Deviation",
		short_name: "DVT",
	},
	[TaskService.customerRelated]: {
		full_name: "Customer related",
		short_name: "CSREL",
	},
	[TaskService.storage]: {
		full_name: "Storage",
		short_name: "STR",
	},
	[TaskService.routines]: {
		full_name: "Routines",
		short_name: "RTN",
	},
	[TaskService.other]: {
		full_name: "Other",
		short_name: "OTH",
	},
	[TaskService.incoming]: {
		full_name: "Incoming",
		short_name: "INC",
	},
	[TaskService.outgoing]: {
		full_name: "Outgoing",
		short_name: "OUTG",
	},
	[TaskService.op]: {
		full_name: "OP",
		short_name: "OP",
	},
	[TaskService.rebuildPallets]: {
		full_name: "Rebuild pallets",
		short_name: "RBLD",
	},
};
